var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('PerPage',{attrs:{"value":_vm.perPage},on:{"change":_vm.onChangePerPage}}),_c('NavPaging',{attrs:{"lastPage":_vm.lastPage,"currentPage":_vm.currentPage},on:{"navigate":_vm.navigate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }